module.exports = __webpack_public_path__ + "img/yt.270a99ed.png";